import React from 'react'
// libs
import { get } from 'lodash'
import { CopyToClipboard } from 'react-copy-to-clipboard'
// icons
import { CloseIcon } from 'components/UI/Icons'
// views
import { Wrapper, Row, Title, EndPointName, LinkToCopy, EndPointWrapper, ParametersWrapper } from './views'
import { Header } from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/components/DetailsForm/components/view'

const InformationCard = ({ hideModal, entity }) => {
  const text = get(entity, 'id')

  return (
    <Wrapper>
      <Header>
        Integration Information
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <EndPointWrapper>
        <p>API End Point</p>
        <EndPointName> {text} </EndPointName>
        <CopyToClipboard text={text} onCopy={() => null}>
          <LinkToCopy>Copy API end point to clipboard</LinkToCopy>
        </CopyToClipboard>
      </EndPointWrapper>
      <ParametersWrapper>
        <p>Integration Parameters</p>
        <Row>
          <Title>Period Commences</Title>
          Start of the reporting for this indicator
        </Row>
        <Row>
          <Title>Period Ends</Title>
          End of the reporting for this indicator
        </Row>
        <Row>
          <Title>Result</Title>
          The indicator result for this period
        </Row>
        <Row>
          <Title>Target</Title>
          The result target for this indicator period
        </Row>
        <Row>
          <Title>Data Source Access Mode</Title>
          {`Either "Link" of "API" providing access to the underlying data set`}
        </Row>
        <Row>
          <Title>Data Source Location</Title>
          The actual URL Link or API end point providing access
        </Row>
      </ParametersWrapper>
    </Wrapper>
  )
}

export default InformationCard
